import { observer } from "mobx-react";

import CreateModal from "@component/CreateModal";
import Contact from "@model/Contact";
import ContactCreateVM from "@vm/Create/Contact";

import ContactForm from "./Form";

import { lazyInject, TYPES } from "../../../../inversify.config";

@observer
export default class ContactCreateModal extends CreateModal<Contact> {
  modelName = "contact";
  prefix = "employee.contact_information";

  @lazyInject(TYPES.ContactCreate)
  vm: ContactCreateVM;

  componentDidMount(): void {
    this.vm.setParentId(this.props.match.params.user_id);
    super.componentDidMount();
  }

  onClose = () => {
    this.router.pageLink(this.uriHelper.employees_contact_informations(this.props.match.params.user_id));
  };

  renderModalBody() {
    return <ContactForm entity={this.vm.entity} />;
  }
}
